import Tags from '../../basic/tags';
import ProductFavorite from './productFavorite';
import { useConfig } from '../../../providers/config-provider';
import { isFavoriteEnabled } from '../../../utils/configUtils';
import { ProductCategoryKeys } from '../../../common/enums/common';
import { UserProfileProps, useUserProfile } from '../../../providers/user-provider';

export default function ProductTags({
  product,
  productTags,
  productType,
  className,
  onFavoriteItemClick,
}: {
  product: any;
  productTags: Array<string>,
  productType?: string,
  className?: string,
  onFavoriteItemClick: (selItem: string, isSelected: boolean) => void;
}): JSX.Element {
  const { config } = useConfig();
  // const authStore = useAuthStore();
  // const isLoggedIn = !!authStore.userProfile
  const { userProfile } = useUserProfile();
  const isLoggedIn = !!userProfile
  const tagItems: Array<string> = productTags;
  const skuid = product.sku;
  return (
    <>
      <div className={'flex w-full items-center h-[22px] md:h-[24px] justify-between'} data-testid="product-tags">
        <div className={className}>
          <Tags items={tagItems} />
        </div>

        <div className="z-25 h-6 md:h-9">
          {isFavoriteEnabled(config, productType as ProductCategoryKeys) ? <ProductFavorite onFavoriteItemClick={onFavoriteItemClick} skuid={skuid} /> : null}
        </div>

      </div>
    </>
  );
}
